import { getEnv } from '../utils/environment';
import { simpleFetch } from './customFetch';

const GET_BOX_SEASON = '/customize/current/seasonal';

const getCustomizeBoxSeasonData = () =>
  simpleFetch({
    uri: GET_BOX_SEASON,
    options: {},
    baseUrl: getEnv().customizeApiEndpoint,
  });

export { getCustomizeBoxSeasonData };
